const Programme = () => {
    return (
        <>
            <div className="slide" id="programme">
                <div className="wrapper">
                    <div id="block-programme">
                        <h1>Programme</h1>
                        <div className="programme-texte">
                            <p>
                                <span className="roll">Notre objectif: </span>
                                faire de toi un-e vidéaste autonome et curieux-se, capable de <span>t’adapter aux multiples formats d’aujourd’hui</span>, du cinéma aux réseaux sociaux.
                            </p>
                        </div>

                        <div className="programme-texte">
                            <p>
                                En 2 ans, explore l’univers varié de la création vidéo en <span>partant de zéro</span>, avec des <span>exercices pratiques</span> mettant en oeuvre le cadrage, la lumière, la prise de son...
                            </p>
                            <div className={"showreel"}>
                                <iframe width="100%" height="100%"
                                        src="https://www.youtube.com/embed/WXwZwiaAGDU?si=adQCxgQETBiJwC_P"
                                        title="YouTube video player" frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen></iframe>
                            </div>
                        </div>

                        <div className="programme-texte arrow">
                            <p>
                                Deux grands projets : une <span>fiction</span> et un <span>documentaire</span>
                            </p>
                        </div>
                    </div>
                    <div id="works">
                    <div className="gauche">
                            <h1>Fictions</h1>
                            <div className="playlist">
                                <iframe width="100%" height="100%"
                                        src="https://www.youtube.com/embed/videoseries?si=UqpdJaNn6Wemln0j&amp;list=PL1gFfQ1Mi187ARKLBPD6BYt5eBmtefLj3"
                                        title="YouTube video player" frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen></iframe>
                            </div>
                            <div className="texte">
                                <p>Écrire une histoire, diriger des comédiens, penser chaque image… Le projet fiction est l’occasion de donner vie à un univers qui t’est propre. </p>
                                <p>
                                    Tu y apprendras à <span>transformer une idée en film</span> : écriture de scénario, découpage, tournage, direction d’équipe, postproduction…
                                </p>
                            </div>
                        </div>
                        <div className="droite">
                            <h1>Documentaires</h1>
                            <div className="playlist">
                                <iframe width={"100%"} height={"100%"}
                                        src="https://www.youtube.com/embed/videoseries?si=SkoRt2zpXuf1t5lO&amp;list=PL1gFfQ1Mi185aA5n-7FNasHsBXhbgTAwL"
                                        title="YouTube video player" frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen></iframe>
                            </div>
                            <div className="texte">
                                <p>Explorer le monde à travers une caméra : le projet documentaire t’immerge dans <span>l'observation du réel</span>.
                                    Tu apprendras à enquêter, rencontrer, écouter et raconter le réel à ta façon.</p>
                                <p>Ce projet t’enseigne l’éthique, l’adaptabilité et te donne une nouvelle façon d’observer le monde.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Programme;